<template>
  <v-dialog
    v-model="dialog"
    persistent
    scrollable
    :fullscreen="$vuetify.display.xs"
    :width="$vuetify.display.smAndUp ? 600 : 'auto'"
    style="z-index: 1100 !important;"
  >
    <template v-slot:activator="{ props }">
      <div v-bind="props" data-cy="podFiles-tree-actions-convertSubtitles-activator">
        <slot />
      </div>
    </template>

    <v-card data-cy="dialog-convertSubtitles-modal">
      <v-card-title class="d-flex justify-space-between">
        {{ $t('routes.pod.subtitleConversion') }}

        <v-btn icon @click="dialog = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>

      <v-card-text data-cy="dialog-convertSubtitles-text">
        <span v-if="isSRT" style="">
          {{ $t('routes.pod.convertSRTToVTTDialogText').replace('{filename}', asset.name) }}
        </span>
        <span v-if="isVTT" style="">
          {{ $t('routes.pod.convertVTTToSRTDialogText').replace('{filename}', asset.name) }}
        </span>

        <div v-if="errorMessage" class="bg-error mt-2" data-cy="dialog-convertSubtitles-error">
          {{ errorMessage }}
        </div>

        <div class="bg-error" v-if="errorTranslatable">
          {{ $replaceT(errorTranslatable.code, errorTranslatable.params, errorTranslatable.content) }}
        </div>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" variant="flat" @click="convertSubtitle" data-cy="dialog-convertSubtitles-ok-btn">
          {{ $t('common.convert') }}
        </v-btn>
        <v-btn variant="text" @click="dialog = false" data-cy="dialog-convertSubtitles-cancel-btn">
          {{ $t('common.cancel') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { usePodStore } from '@/stores/PodStore.js';
import { useCommonStore } from '@/stores/CommonStore.js'
import DialogActionKeys from '@/components/mixin/DialogActionKeys.js';
import DialogModel from '@/components/mixin/DialogModel.js';

export default {
  mixins: [DialogActionKeys, DialogModel],
  name: "ConvertSubtitleDialog",
  props: {
    asset: {
      type: Object,
      required: false
    }
  },
  data: function() {
    return {
      errorMessage: "",
      errorTranslatable: null,
    }
  },
  computed: {
    assetTypes: function() {
      const commonStore = useCommonStore();
      return commonStore.assetTypes;
    },
    isSRT: function() {
      return this.asset.type === this.assetTypes.SRT;
    },
    isVTT: function() {
      return this.asset.type === this.assetTypes.VTT;
    },
  },
  watch: {
    dialog: function(newValue) {
      if (newValue) {
        this.errorMessage = "";
      }
    }
  },
  methods: {
    convertSubtitle: function() {
      this.errorMessage = "";
      this.errorTranslatable = null;

      let self = this;
      const podStore = usePodStore();
      podStore.convertSubtitle(this.asset)
      .then(function() {
        self.dialog = false;
      })
      .catch(function(error) {
        if (error && error.response && error.response.data && error.response.data.error) {
          const apiError = error.response.data.error.message;
          if (typeof apiError == 'object') {
            self.errorTranslatable = apiError;
          } else {
            self.errorMessage = apiError;
          }
        } else {
          self.errorMessage = "Error!";
          console.log(error);   // unhandled error
        }
      });
    },
  },
}
</script>

<style>

</style>
